import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/statics/fonts/NeutrafaceText-BoldItalic.woff2%22,%22weight%22:%22700%22,%22style%22:%22italic%22},{%22path%22:%22../../public/statics/fonts/NeutrafaceText-BoldItalic.woff%22,%22weight%22:%22700%22,%22style%22:%22italic%22}],%22variable%22:%22--font-neutraface-text%22}],%22variableName%22:%22NeutrafaceText%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'NeutrafaceText', 'NeutrafaceText Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
